/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DuplicateStudyPlanRequest
 */
export interface DuplicateStudyPlanRequest {
    /**
     * 
     * @type {string}
     * @memberof DuplicateStudyPlanRequest
     */
    studyPlanId?: string;
    /**
     * 
     * @type {number}
     * @memberof DuplicateStudyPlanRequest
     */
    newPlanYear?: number;
}

export function DuplicateStudyPlanRequestFromJSON(json: any): DuplicateStudyPlanRequest {
    return DuplicateStudyPlanRequestFromJSONTyped(json, false);
}

export function DuplicateStudyPlanRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DuplicateStudyPlanRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'studyPlanId': !exists(json, 'studyPlanId') ? undefined : json['studyPlanId'],
        'newPlanYear': !exists(json, 'newPlanYear') ? undefined : json['newPlanYear'],
    };
}

export function DuplicateStudyPlanRequestToJSON(value?: DuplicateStudyPlanRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'studyPlanId': value.studyPlanId,
        'newPlanYear': value.newPlanYear,
    };
}

